import { render, staticRenderFns } from "./VendorTile.vue?vue&type=template&id=9b53f384&scoped=true&"
import script from "./VendorTile.vue?vue&type=script&lang=js&"
export * from "./VendorTile.vue?vue&type=script&lang=js&"
import style0 from "./VendorTile.vue?vue&type=style&index=0&id=9b53f384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b53f384",
  null
  
)

export default component.exports